import { ORDER_STATUS_LABELS, OrderStatus } from '@kick/types';
import { cn } from '@/lib/cn';

/** Color por estado: azul mientras avanza, verde al entregar, rojo si se cayó. */
const COLORES: Record<OrderStatus, string> = {
  [OrderStatus.PENDING_PAYMENT]: 'bg-amber-100 text-amber-800',
  // Ámbar como lo que espera: todavía no ha empezado nada.
  [OrderStatus.SCHEDULED]: 'bg-amber-100 text-amber-800',
  [OrderStatus.PLACED]: 'bg-sky-100 text-sky-800',
  [OrderStatus.ACCEPTED]: 'bg-sky-100 text-sky-800',
  [OrderStatus.PREPARING]: 'bg-indigo-100 text-indigo-800',
  [OrderStatus.READY_FOR_PICKUP]: 'bg-violet-100 text-violet-800',
  [OrderStatus.PICKED_UP]: 'bg-violet-100 text-violet-800',
  [OrderStatus.ON_THE_WAY]: 'bg-violet-100 text-violet-800',
  [OrderStatus.DELIVERED]: 'bg-emerald-100 text-emerald-800',
  [OrderStatus.CANCELLED]: 'bg-red-100 text-red-800',
  [OrderStatus.REJECTED]: 'bg-red-100 text-red-800',
};

export function EtiquetaEstado({ estado, className }: { estado: OrderStatus; className?: string }) {
  return (
    <span
      className={cn(
        'inline-block rounded-full px-2.5 py-0.5 text-xs font-semibold',
        COLORES[estado],
        className,
      )}
    >
      {ORDER_STATUS_LABELS[estado]}
    </span>
  );
}
